module.exports = __webpack_public_path__ + "static/media/Mesa-Portaprent.9165ade6.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Section-Productos/Imagen/Mesa-Portaprent.png
// module id = 126
// module chunks = 0